import React from 'react';
import { contextPresentation } from './contextPresentation';
import './ContextShelf.css';

/**
 * ContextShelf — the J2 list of context chips (#1921), exported per the
 * #1921 blocking precondition so #1923's learner-home variant can reuse it.
 *
 * Renders exactly the contexts the API returned, in the order it returned
 * them (backend fixes presentation order to the taxonomy's own declared
 * order, `SCENARIO_CONTEXTS` — this component does not re-sort). Counts are
 * always the API's dynamic count, never hardcoded (gate decision).
 */
function ContextShelf({ contexts, onSelect }) {
  return (
    <div className="gd-context-shelf" role="list">
      {contexts.map((ctx) => {
        const { icon, example } = contextPresentation(ctx.slug);
        return (
          <button
            key={ctx.slug}
            type="button"
            role="listitem"
            className="gd-context-row"
            data-testid={`gd-context-row-${ctx.slug}`}
            onClick={() => onSelect(ctx.slug)}
          >
            <span className="gd-context-row__icon" aria-hidden="true">{icon}</span>
            <span className="gd-context-row__text">
              <span className="gd-context-row__title">{ctx.label}</span>
              {example && <span className="gd-context-row__example">{example}</span>}
            </span>
            <span className="gd-context-row__count">{ctx.count}</span>
          </button>
        );
      })}
    </div>
  );
}

export default ContextShelf;
